import actions from './actions';
import actionTypes from './constants/action-types';
import reducers from './reducers';
import selectors from './selectors';
import accessors from './accessors';

export default {
  actions,
  actionTypes,
  reducers,
  selectors,
  accessors,
};
